import { render, staticRenderFns } from "./receivableWriteOff.vue?vue&type=template&id=54e592d2&scoped=true&"
import script from "./receivableWriteOff.vue?vue&type=script&lang=js&"
export * from "./receivableWriteOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e592d2",
  null
  
)

export default component.exports